<template>
      <div no-body class="lku-adv"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col lg="12">
            <b-input-group >
                <b-input-group-prepend><label >Adv. Number</label></b-input-group-prepend>
                <b-form-input v-model="tblData.nomor" @keyup.13.native="refresh()" size="sm" placeholder="Cash-advance. No"></b-form-input>
                <b-input-group-prepend><label class="text-right">Description</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.uraian" @keyup.13.native="refresh()" size="sm" style="width:40% !important;" placeholder="Description" ></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label >Create By</label></b-input-group-prepend>
              <b-form-input v-model="tblData.createby" @keyup.13.native="refresh()" size="sm" placeholder="Request By"></b-form-input>
              <b-input-group-prepend><label class="text-right">Paid To</label></b-input-group-prepend>
                <b-form-input v-model="tblData.dibayarke" @keyup.13.native="refresh()" size="sm" placeholder="Paid to"></b-form-input>
                <b-input-group-prepend><label class="text-right">Approval </label></b-input-group-prepend>
                <b-form-select v-model="tblData.statuswf" :plain="true" :options="dataList.approvalStatus"></b-form-select>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-3" @click="refresh()" size="sm"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear </b-button>
                </b-input-group-append>
                
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblAdv"
          responsive
          striped hover small 
          style="font-size:smaller;" 
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          @row-clicked="selectItem"
        >
          <template v-slot:cell(jumlah)="data">
            {{data.item.matauang}} {{data.item.jumlah | numFormat}}
          </template>
          <template v-slot:cell(outstand)="data">
            {{data.item.outstand | numFormat('0,0.00')}}
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>


      </div>
</template>
<style lang="scss">
  .lku-adv {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
    .input-group-prepend {
        label {
            padding-top: 5px;
            padding-right: 5px;
            width: 85px;
        }
    }

  }
</style>

<script>
import advance from "../../apis/advance";
import dropdown from "../../data/dropdown";

export default {
  data() {
    return {
      lkuLoading:false,
      fields: [
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Trx. Number",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
          },
          {
            key: "dibayarke",
            label: "Paid to",
            sortable: true
          },
          {
            key: "jumlah",
            label: "Requested Amt.",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "outstand",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        outstand:'1', statuswf:'111'
      },
      updatetable:false,
      dataList: {
        approvalStatus:dropdown.approvalStatus,
      },      
    };
  },

  computed: {
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    pagechange: function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    limitchange: function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
  },

  created: async function() {
          if (this.formdata)
          {
              for (var key in this.formdata) {
                  this.tblData[key] = this.formdata[key];
              }
          }
  
  },

  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    // data: async function() {
    //   this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

    //   const list = await advance.list(this.tblData);          
    //   return list;
    // },

    // selectItem(item,index) {
    //   // 'item' will be the row data from items
    //   // `index` will be the visible row number (available in the v-model 'shownItems')
    //   this.$emit("click", item);
    // },
    data: async function(ctx) {
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
          this.lkuLoading=true;
          const list = await advance.list(this.tblData);      
          this.lkuLoading=false;
          this.tblData.items=list;
          this.updatetable=!this.updatetable;
          // console.log('this.tblData : ',this.tblData);
        },
    selectItem(item,index) {
          this.$emit("click", item);
          //this.tblData.selected=item;
          //this.$emit("click", this.tblData);
        },
    clearFilter() {
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.dibayarke=  '';
        // this.refresh();
    },    
    // refresh: async function() {
    //   this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
    //   this.lkuLoading=true;
    //   this.items= await advance.list(this.tblData); 
    //   console.log("#this.items: ", this.items);   
    //   this.lkuLoading=false;
    //   this.$refs.tblAdv.refresh();
    // }
    refresh() {
      this.data();
      this.$refs.tblAdv.refresh();
    }
  }
};
</script>
